import { useState, useEffect } from "react";
import { apiFetch } from "../../core/utils/api";

/**
 * Fetches whether a global access grant is currently active.
 * Defaults to false on any error or while loading.
 *
 * @returns {boolean} true when the global access grant is active
 */
const useGlobalAccessGrantActive = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const resp = await apiFetch("/api/global-access-grant/active/", {
          suppressUnauthorizedEvent: true,
        });
        const data = await resp.json().catch(() => null);
        if (!cancelled && resp.ok && data) {
          setIsActive(Boolean(data.active));
        }
      } catch {
        // Default to false on any failure.
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return isActive;
};

export default useGlobalAccessGrantActive;
